import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SearchState {
  state: any;
  history: string[];
}

const initialState: SearchState = { state: null, history: [] };

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    addHistory: (state, action: PayloadAction<string>) => {
      if(!action?.payload?.length) return;
      const newHistory: string[] = state.history.filter((search: string) => search !== action.payload)
      state.history = [...newHistory, action.payload];
    },
    removeHistory: (state, action: PayloadAction<string>) => {
      state.history = state.history.filter((search: string) => search !== action.payload)
    },
    clearHistory: (state) => {
      state.history = [];
    },
  },
});

export const {
  reducer: searchReducer,
  actions: searchActions,
} = searchSlice;
